// import LoginHHMTBanner from 'assets/images/login-hhmt-banner.png';
// import LoginRemoxBanner from 'assets/images/login-remox-banner.png';
import EventAvailableModal from 'components/Events/components/EventAvailableModal';
import EventAvailableModalMobile from 'components/Events/components/EventAvailableModal/mobile';
import {
  ACCOUNT_ACTIVATION_PREFIX,
  CALCULATOR_FORM_PREFIX,
  DESKTOP_MIN_WIDTH,
  EVENT_PREFIX,
  FORGOT_PASSWORD_PREFIX,
  FX_CALCULATOR_FORM_PREFIX,
  FX_PAYMENT_PROCESS_PREFIX,
  LOGIN_PREFIX,
  MAINTENANCE_PREFIX,
  PAYMENT_PROCESS_PREFIX,
  RECEIVERS_EDIT_SUFIX,
  RECEIVERS_UPDATE_SUFIX,
  REGISTER_PREFIX,
  RESET_PASSWORD_PREFIX,
} from 'constants';
import useAddDocumentTitle from 'hooks/useAddDocumentTitle';
import useAuth from 'hooks/useAuth';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import usePage from 'hooks/usePage';
import usePageCleanUp from 'hooks/usePageCleanUp';
import usePageYOffset from 'hooks/usePageYOffset';
import useRefreshTokenTrigger from 'hooks/useRefreshTokenTrigger';
import useScaleMobileViewport from 'hooks/useScaleMobileViewport';
import useStore from 'hooks/useStore';
import useTheme from 'hooks/useTheme';
import useTokenExpired from 'hooks/useTokenExpired';
import { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import BackdropGlobal from '../BackdropGlobal';
import Footer from '../Footer';
import Footer2 from '../Footer2';
import HeaderMobile from '../Header/ver2/mobile';
import Header from '../Header/ver3';
import LoadingScreen from '../LoadingScreen/ver2';
import PendingScreen from '../PendingScreen';
import PortalModal from '../PortalModal';
import RefreshTokenPopup from '../RefreshTokenPopup';

const pathsHideFooter = [
  LOGIN_PREFIX,
  FORGOT_PASSWORD_PREFIX,
  RESET_PASSWORD_PREFIX,
  ACCOUNT_ACTIVATION_PREFIX,
  REGISTER_PREFIX,
  RECEIVERS_EDIT_SUFIX,
  RECEIVERS_UPDATE_SUFIX,
  PAYMENT_PROCESS_PREFIX,
  FX_PAYMENT_PROCESS_PREFIX,
  CALCULATOR_FORM_PREFIX,
  FX_CALCULATOR_FORM_PREFIX,
  EVENT_PREFIX,
  MAINTENANCE_PREFIX,
];

const pathsShowFooter2 = [
  LOGIN_PREFIX,
  FORGOT_PASSWORD_PREFIX,
  RESET_PASSWORD_PREFIX,
  ACCOUNT_ACTIVATION_PREFIX,
];

const pathsHideHeader = [
  PAYMENT_PROCESS_PREFIX,
  CALCULATOR_FORM_PREFIX,
  FX_PAYMENT_PROCESS_PREFIX,
  FX_CALCULATOR_FORM_PREFIX,
  EVENT_PREFIX,
  MAINTENANCE_PREFIX,
];

const Layout = ({ children }) => {
  const { t } = useLang();
  const { state } = useStore();
  const { backdrop, isLoading, isPending, eventAvailable, portalModal } = state;
  const { isAuthenticated } = useAuth();
  const { isHHMTTheme } = useTheme();
  const { isDesktop, isMobile, isTablet } = useDetectDevice();

  const { isShowPortalModal } = portalModal || {};

  const { pathname } = useLocation();
  const isFooterHidden = pathsHideFooter?.find((path) => {
    if (path === RECEIVERS_EDIT_SUFIX && pathname.includes(path)) {
      return true;
    }

    if (path === RECEIVERS_UPDATE_SUFIX && pathname.includes(path)) {
      return true;
    }

    if (path === CALCULATOR_FORM_PREFIX && pathname.includes(path)) {
      return true;
    }

    if (path === FX_CALCULATOR_FORM_PREFIX && pathname.includes(path)) {
      return true;
    }

    if (path === FX_PAYMENT_PROCESS_PREFIX && pathname.includes(path)) {
      return true;
    }

    if (path === PAYMENT_PROCESS_PREFIX && pathname.includes(path)) {
      return true;
    }

    if (path === EVENT_PREFIX && pathname.includes(path)) {
      return true;
    }

    return pathname === path;
  });
  const isShowFooter2 = pathsShowFooter2?.find((path) => {
    return pathname === path;
  });

  const isHeaderHidden = pathsHideHeader?.find((path) => {
    if (path === CALCULATOR_FORM_PREFIX && pathname.includes(path)) {
      return true;
    }

    if (path === FX_CALCULATOR_FORM_PREFIX && pathname.includes(path)) {
      return true;
    }

    if (path === FX_PAYMENT_PROCESS_PREFIX && pathname.includes(path)) {
      return true;
    }

    if (path === PAYMENT_PROCESS_PREFIX && pathname.includes(path)) {
      return true;
    }

    if (path === EVENT_PREFIX && pathname.includes(path)) {
      return true;
    }

    return pathname === path;
  });

  const [pageYOffset, setPageYOffset] = useState(0);

  const {
    isLoginPage,
    isForgotPasswordPage,
    isResetPasswordPage,
    isAccountActivationPage,
    isDashboardPage,
    isTransactionsPage,
    isReceiversPage,
    isEditReceiverPage,
    isUpdateReceiverPage,
    isAddReceiverPage,
    isAddTransactionPage,
    isEventPage,
    isFxDashboardPage,
    isFxTransactionsPage,
    isFxAddTransactionPage,
    isOffersVouchersPage,
    isOffersPromotionsPage,
    isOffersPromotionsOfEventPage,
    isProfilePage,
    isSercurityPage,
    isNotificationsPage,
    isReferralPage,
  } = usePage();

  const isShowEventModal = isAuthenticated && !isEventPage && eventAvailable;

  useAddDocumentTitle();

  useEffect(() => {
    const appRootEle = document.getElementById('application-root');
    const bodyEle = document.getElementsByTagName('body')[0];
    const customContainerEle =
      document.getElementsByClassName('custom-container')[0];
    console.log('Layout useEffect triggered:', t('login_hhmt_background_img'));
    if (isDesktop) {
      if (
        isLoginPage ||
        isForgotPasswordPage ||
        isResetPasswordPage ||
        isAccountActivationPage
      ) {
        appRootEle.style.backgroundPositionX = `center`;
        appRootEle.style.backgroundPositionY = `72px`;
        customContainerEle.style.paddingBottom = `0px`;
        customContainerEle.style.display = `grid`;

        if (isHHMTTheme) {
          appRootEle.style.backgroundImage = `url(${t(
            'login_hhmt_background_img',
          )})`;
          appRootEle.style.backgroundColor = `var(--ds-c-grey-dark)`;

          return;
        }

        appRootEle.style.backgroundImage = `url(${t(
          'login_remox_background_img',
        )})`;
        appRootEle.style.backgroundColor = `var(--ds-c-blue-dark)`;

        return;
      }

      if (
        isDashboardPage ||
        isAddTransactionPage ||
        isTransactionsPage ||
        isAddReceiverPage ||
        isReceiversPage ||
        isFxAddTransactionPage ||
        isFxDashboardPage ||
        isFxTransactionsPage ||
        isOffersVouchersPage ||
        isOffersPromotionsPage ||
        isOffersPromotionsOfEventPage ||
        isProfilePage ||
        isSercurityPage ||
        isNotificationsPage ||
        isReferralPage
      ) {
        appRootEle.style.backgroundImage = 'none';
        appRootEle.style.backgroundColor = isHHMTTheme
          ? `var(--ds-c-bg-light-grey)`
          : 'var(--ds-c-bg-light-grey)';
        bodyEle.style.backgroundColor = isHHMTTheme
          ? `var(--ds-c-bg-light-grey)`
          : 'var(--ds-c-bg-light-grey)';
        customContainerEle.style.paddingBottom = `48px`;

        return;
      }
    } else {
      appRootEle.style.backgroundImage = 'none';
      appRootEle.style.backgroundColor = '#ffffff';
      bodyEle.style.backgroundColor = '#ffffff';
      return;
    }

    appRootEle.style.backgroundImage = 'none';
    appRootEle.style.backgroundColor = '#ffffff';
    bodyEle.style.backgroundColor = '#ffffff';
  }, [
    isHHMTTheme,
    isDesktop,
    isLoginPage,
    isForgotPasswordPage,
    isResetPasswordPage,
    isAccountActivationPage,
    isDashboardPage,
    isTransactionsPage,
    isReceiversPage,
    isEditReceiverPage,
    isUpdateReceiverPage,
    isAddReceiverPage,
    isAddTransactionPage,
    isAddTransactionPage,
    isFxDashboardPage,
    isFxAddTransactionPage,
    isOffersVouchersPage,
    isOffersPromotionsPage,
    isOffersPromotionsOfEventPage,
    isProfilePage,
    isSercurityPage,
    isNotificationsPage,
    isReferralPage,
  ]);

  useTokenExpired();

  useRefreshTokenTrigger();

  usePageYOffset(setPageYOffset);

  useScaleMobileViewport();

  usePageCleanUp();

  if (isMobile || isTablet) {
    return (
      <>
        <LoadingScreen pageYOffset={pageYOffset} isOpen={isLoading} />

        {isPending && (
          <PendingScreen pageYOffset={pageYOffset} isOpen={isPending} />
        )}

        {isAuthenticated && <RefreshTokenPopup />}

        {isShowEventModal && (
          <EventAvailableModalMobile isOpen={isShowEventModal} />
        )}

        {isShowPortalModal && <PortalModal />}

        <ContainerStyled className="custom-container">
          {backdrop?.isShow && <BackdropGlobal pageYOffset={pageYOffset} />}
          {isHeaderHidden ? null : <HeaderMobile />}
          {children}
        </ContainerStyled>
      </>
    );
  }
  return (
    <>
      <LoadingScreen pageYOffset={pageYOffset} isOpen={isLoading} />

      {isPending && (
        <PendingScreen pageYOffset={pageYOffset} isOpen={isPending} />
      )}

      {isAuthenticated && <RefreshTokenPopup />}

      {isShowEventModal && <EventAvailableModal isOpen={isShowEventModal} />}

      {isShowPortalModal && <PortalModal />}

      {isHeaderHidden ? null : <Header />}

      <ContainerStyled
        className="custom-container"
        $isScreenFit={
          isLoginPage ||
          isForgotPasswordPage ||
          isResetPasswordPage ||
          isAccountActivationPage
        }
      >
        {children}
      </ContainerStyled>

      {isFooterHidden ? null : <Footer />}

      {isShowFooter2 ? <Footer2 /> : null}
    </>
  );
};

const ContainerStyled = styled(Container)`
  width: 100%;
  max-width: 100%;
  height: fit-content;
  padding: 0;
  margin-inline: auto;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    max-width: ${DESKTOP_MIN_WIDTH}px;
    height: ${(props) => props.$isScreenFit && '100dvh'};
  }

  @media screen and (min-width: 1440px) {
    max-width: 1440px;
  }

  @media screen and (min-width: 1920px) {
    height: ${(props) => props.$isScreenFit && 'calc(100dvh - 93px)'};
  }
`;

export default Layout;
